/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import * as FacialActions from 'store/ducks/facial/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import FACIAL from 'constants/facial';

// Styles
import useStyles from './approvalStatusFilter.styles';

const ApprovalStatusFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const approvalStatus = useSelector(
    (state: ApplicationState) => state.facial.selectedApprovalStatus,
  );

  const handleApprovalStatus = (status: number) => {
    const found = approvalStatus.filter((e) => e === status);
    dispatch(
      FacialActions.setSelectedApprovalStatus({
        selectedApprovalStatus:
          found.length > 0
            ? approvalStatus.filter((e) => e !== status)
            : [...approvalStatus, status],
      }),
    );
  };

  return (
    <List dense>
      {Object.values(FACIAL.APPROVAL).map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleApprovalStatus(item.VALUE)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleApprovalStatus(item.VALUE)}
              checked={
                approvalStatus.filter((e) => e === item.VALUE).length > 0
              }
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { ApprovalStatusFilter };
export default ApprovalStatusFilter;
